import {
  withTranslation,
} from 'react-i18next';

import RegattaResultOverallFieldsView from './RegattaResultOverallFieldsView';

const TranslatedComponent = withTranslation()(RegattaResultOverallFieldsView);

const Component = TranslatedComponent;

export default Component;
